controllers.controller('WelcomeController', [
    '$scope', '$state', '$ionicNavBarDelegate',
    'config', 'constants', 'LocaleService', 'Utils',
    function ($scope, $state, $ionicNavBarDelegate, config, Const, LocaleService, Utils) {
        $ionicNavBarDelegate.showBar(false);

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.languages = config.languages;
        $scope.demoAccountCreateAfterSignup = Const['demoAccountCreateAfterSignup'];
        $scope.languageSelectorMarginTop = Const['languageSelectorMarginTop'];

        $scope.disableSignUp = Const['disableSignup'];
        $scope.const = Const;

        $scope.navigateExternalUrl = function(url, openInBroweser) {
            var popupOptions = 'location=no,hidden=no,toolbar=yes,fullscreen=yes,closebuttoncaption=Back,closebuttoncolor=#00AFAA,navigationbuttoncolor=#00AFAA';
            var target = openInBroweser ? '_system' : '_blank'
            window.cordova && window.cordova.InAppBrowser ? window.cordova.InAppBrowser.open(encodeURI(url), target, popupOptions) : window.open(encodeURI(url), '_system');
        };

        $scope.authType = Const['authType'] ? Const['authType'] : 'newforex';
        function setLanguage() {
            $scope.language = config.languages.find(function (language) {
                return language.id === LocaleService.lang;
            });
            $scope.translation = LocaleService.translation;
            $scope.signUpURL = Utils.createLinkByLang('externalLinks.signUp', LocaleService.lang, 'externalLinks.signUpDefault');
        }

        setLanguage();

        $scope.$watch(function () {
            return LocaleService.lang
        }, function (newVal, oldVal) {
            if (newVal && newVal !== oldVal) setLanguage();
        });

        $scope.updateLang = function (language) {

            LocaleService.load(language.id)
                .then(function () {
                    $scope.translation = LocaleService.translation;
                    // $scope.language = { id: LocaleService.lang };
                    setLanguage();
                });
        };

        $scope.navigate = function (state, params) {
            $state.go(state, params);
        };

    }]);
